import useDocumentPreview from '../hooks/useDocumentPreview';

const DocumentPreview = ({ itemProps, data, setActiveView }) => {
  const { documentSrc } = useDocumentPreview({
    activeView: {
      itemProps,
      data
    },
    setActiveView
  });

  return (
    <iframe
      src={documentSrc}
      style={{
        width: '924px',
        height: '11.69in',
        objectFit: 'contain',
        maxHeight: 'calc(100vh - 175px)'
      }}
    />
  );
};

export default DocumentPreview;
